import Icon from "newComponents/Shared/_Atoms/Icons/Icon/Icon";
import React, { FC } from "react";

interface IProps {
  handleLogout: () => void;
}

const LogoutButton: FC<IProps> = ({ handleLogout }) => {
  return (
    <div className="sidenav-logout-container" onClick={handleLogout}>
      <Icon icon="logout" className="sidenav-logout-logo" />
      Logout
    </div>
  );
};

export default LogoutButton;
